export const FETCH_SEARCH_SUGGESTIONS = "FETCH_SEARCH_SUGGESTIONS";
export const FETCH_SEARCH_SUGGESTIONS_SUCCESS = "FETCH_SEARCH_SUGGESTIONS_SUCCESS";
export const FETCH_SEARCH_SUGGESTIONS_FAILURE = "FETCH_SEARCH_SUGGESTIONS_FAILURE";
export const CLEAR_SEARCH_SUGGESTIONS = "CLEAR_SEARCH_SUGGESTIONS";
